import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 radius-7 bg-white stats-item card-realtime-custom-mobile" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 pt-lg-30 letter-spacing heigth-card-realtime align-items-center d-flex" }
const _hoisted_3 = { class: "row justify-content-between" }
const _hoisted_4 = { class: "col-lg-5 col-md-5 flex-card-custom" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "icon position-relative text-info-light rounded-1 text-center icon-realtime-custom-mobile" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-folder-1" })
], -1)
const _hoisted_6 = { class: "flex-lg-column ml-10 info d-flex align-items-center text-cards-realtime custom-realtime-title-mobile" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "fs-13 d-block text-uppercase text-dark-emphasis fw-bold" }, " TAMANHO TOTAL DE UPLOAD ", -1)
const _hoisted_8 = { class: "d-flex align-items-center width-100 mt-2 custom-realtime-title-mobile" }
const _hoisted_9 = { class: "fw-black mb-0 me-10 lh-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h4", _hoisted_9, _toDisplayString((_ctx.getCardsRealtime.total_size / (1024 * 1024)).toFixed(2) + " MB"), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}